<template>
  <div class="bg">
    <!-- banner   -->
    <div class="banner">
      <div class="content-1200 H100 flex-column flex-centent">
        <div class="title fontWeight-800 fontSize48">金标认证</div>
        <div class="desc fontSize16 color-level4">
          金标认证服务旨在甄选在稳定性、性能、功耗、安全、隐私等方面均达到行业领先水平的应用，并在小米、OPPO、vivo、荣耀、联想等品牌的应用市场中向用户推介。提升应用服务品质，提高用户信任感与认同感。
        </div>
        <more-button text="申请认证" @handleClick="$router.push('/console/goldIdentification/list')"></more-button>
      </div>
    </div>
    <reveal-animation>
      <!-- 认证价值   -->
      <div class="worth content-1200">
        <div class="worth-title fontWeight-800 fontSize36 color-level1 text-center">认证价值</div>
        <div class="worth-content  flex-nowrap space-between">
          <div v-for="(item,index) in worthData" :key="index" class="radius-8 relative">
            <img :src="require(`@/assets/img/service/${item.src}`)" alt="" class="absolute">
            <div class="title font-blod fontSize18 white">{{ item.title }}</div>
            <div class="desc fontSize14 color-level4">{{ item.content }}</div>
          </div>
        </div>
      </div>
    </reveal-animation>
    <reveal-animation>
      <!-- 认证示例   -->
      <div class="example content-1200">
        <div class="main-title fontWeight-800 fontSize36 color-level1 text-center">认证示例</div>
        <div class="example-content flex-nowrap space-between">
          <div v-for="(item,index) in exampleData" :key="index" class="radius-8 relative">
            <img :src="require(`@/assets/img/service/${item.src}`)" alt="" class="pic relative">
            <img :src="require(`@/assets/img/service/${item.icon}`)" alt="" class="icon absolute">
            <div class="desc fontSize14 color-level2 text-center">{{ item.content }}</div>
          </div>
        </div>
        <img class="W100" src="@/assets/img/service/example_banner.png" alt="">
      </div>
    </reveal-animation>
    <reveal-animation>
      <!-- 认证流程   -->
      <div class="process content-1200">
        <div class="main-title fontWeight-800 fontSize36 color-level1 text-center">认证流程</div>
        <div class="process-content flex-nowrap space-between">
          <div v-for="(item,index) in processData" :key="index" class="radius-8 relative text-center">
            <img :src="require(`@/assets/img/service/${item.src}`)" alt="" class="pic">
            <img v-if="index + 1 !== processData.length" src="@/assets/img/service/process_arrow.png" alt=""
                 class="absolute arrow">
            <div class="step color-level2 fontWeight-500">STEP 0{{ index + 1 }}</div>
            <div class="font-blod color-level1">{{ item.content }}</div>
          </div>
        </div>
      </div>
    </reveal-animation>
    <reveal-animation>
      <!-- 金标应用  -->
      <App/>
    </reveal-animation>
    <!-- 获得金标认证 -->
    <div class="join flex-center">
      <reveal-animation :options="{duration:1000,delay:0}">
        <div class="flex-center flex-column">
          <div class="title fontSize24 margin-b20 font-blod">获得金标认证，成为应用市场优先推荐应用</div>
          <div class="btn text-center font-blod color-level1 cursor"
               @click="$router.push('/console/goldIdentification/list')">申请认证
          </div>
        </div>
      </reveal-animation>
    </div>
  </div>
</template>

<script>
import {
  processData,
  worthData,
  exampleData
} from "@/common/VO/serviceVO";
import MoreButton from "@/components/common/MoreButton";
import App from "./components/App";
import RevealAnimation from "@/components/common/RevealAnimation";

export default {
  name: "Service",
  metaInfo: {
    title: "ITGSA | 移动智能终端生态专业委员会 | 金标认证",
    meta: [
      {
        name: 'keywords',
        content: '行业认同，用户信任，应用市场推介，系统服务优先，生态参与优先'
      },
      {
        name: 'description',
        content: '金标认证服务旨在甄选出在稳定性、兼容性、性能、功耗、安全、隐私等方面均达到行业领先水平的应用，并在小米、OPPO、vivo、荣耀等品牌的应用市场中向用户推介。提升应用服务品质，提高用户信任感与认同感。'
      },
    ]
  },
  components: {MoreButton, App, RevealAnimation},
  data() {
    return {
      // 认证价值
      worthData: worthData(),
      // 认证示例
      exampleData: exampleData(),
      // 认证流程
      processData: processData(),
    };
  },


  methods: {},
};
</script>

<style lang="scss" scoped>
.main-title {
  margin-bottom: 60px;
}

.banner {
  width: 100%;
  height: 600px;
  background-image: url("~@/assets/img/service/banner.jpg");
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;

  .title {
    margin-bottom: 12px;
    background: linear-gradient(359.9999999898547deg, #F5CE99 0%, #FFF2C6 52%, #F5CE99 100%);
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
    -webkit-text-fill-color: transparent;
  }

  .desc {
    width: 644px;
    margin-bottom: 32px;
    line-height: 27px;
  }

  .more-btn {
    background: linear-gradient(90deg, #F5CE99 0%, #FFF2C6 52%, #F5CE99 100%);
    border: 1px solid transparent;
    margin: initial;
    color: $color-level1;
    font-weight: 700;
  }
}

.worth {
  padding: 80px 0 40px;

  &-title {
    margin-bottom: 111px;
  }

  &-content > div {
    background: #262626;
    width: 224px;
    height: 300px;
    padding: 161px 20px 0;
    transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);

    &:hover {
      transform: translateY(-20px);
      box-shadow: 0 10px 13px 0 rgba(213, 213, 213, 0.5);
    }

    img {
      width: 200px;
      height: 200px;
      top: -80px;
      left: 12px;
    }

    .title {
      margin-bottom: 13px;
      position: relative;
      padding-left: 16px;
      height: 24px;
      line-height: 24px;

      &:before {
        position: absolute;
        content: "";
        display: inline-block;
        width: 4px;
        height: 24px;
        background: #CEC298;
        left: 0;
        top: 0;
      }
    }

    .desc {
      line-height: 24px;
    }

  }

}

.example {
  padding: 80px 0 40px;

  &-content {
    margin-bottom: 60px;
    padding-left: 14px;

    & > div {
      width: 214px;

      .pic {
        width: 100%;
        margin-bottom: 24px;
      }

      .icon {
        width: 100px;
        top: 144px;
        left: -20px;
      }
    }
  }
}

.process {
  padding: 80px 0 40px;

  &-content {
    & > div {
      flex: 1;

      img {
        width: 60px;
        height: 60px;
      }
    }

    .pic {
      margin-bottom: 24px;
    }

    .arrow {
      width: 48px;
      height: 12px;
      top: 31px;
      right: -24px;
    }

    .step {
      height: 24px;
      margin-bottom: 4px;
    }
  }
}

.app {
  padding: 80px 0 120px;

  &-content {
    width: 1200px;
    overflow: hidden;

    ul {
      height: 420px;
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
      overflow-y: auto;

      &::-webkit-scrollbar {
        display: none; /* 隐藏滚动条 */
      }

      li {
        width: 100px;
        height: 100px;
        margin: 0 57px 40px 0;

        img {
          width: 100px;
          height: 100px;
          box-shadow: 0 12px 24px -12px rgba(0, 0, 0, 0.1);
          border-radius: 16px;
        }
      }
    }

  }
}

.join {
  width: 100%;
  height: 200px;
  background-image: url("~@/assets/img/service/join.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;

  .title {
    background: linear-gradient(359.9999999898547deg, #CEC298 0%, #FFF2C6 52%, #D4C79D 100%);
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
    -webkit-text-fill-color: transparent;
  }

  .btn {
    width: 160px;
    height: 40px;
    line-height: 40px;
    background: linear-gradient(90deg, #F5CE99 0%, #FFF2C6 52%, #F5CE99 100%);
    border-radius: 59px 59px 59px 59px;
  }
}
</style>
